import { Component, OnInit } from '@angular/core';
import { ServiceTypeEnum, RootMenuEnum, MenuPermissionActionEnum, MenuPermissionConfig } from 'app/models';
import { AppDataService } from 'app/services';
import { AppComponent } from 'app/app.component';

export enum MarketingMenuEnum {
    AllPromotions = 1,
    PromotionsPerformance = 2,
    AllCampaigns = 3,
    AdvertisementsPerformance = 4,
    AdvertisementsSettings = 5,
    CustomerQuest = 6,
    IncentiveQuest = 7,
	DiscountsReport = 8,
	ReferralReport = 9,
	PromoBudgets = 10,
	PromoSponsors = 11,
    PromotionMaterials = 12
}

@Component({
    selector: 'marketing-root',
    templateUrl: './marketing-root.component.html',
    styleUrls: ['./marketing-root.component.scss',
        '../../../../styles/menu-sidebar.scss'
    ],
})
export class MarketingRootComponent implements OnInit {

    public serviceTypeId!: ServiceTypeEnum;

    constructor(public appData: AppDataService,
                public app: AppComponent) { }

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    public activeRootMenu: RootMenuEnum | null = null;

    public menuEnum = MarketingMenuEnum;
    public activeMenu!: MarketingMenuEnum;

    ngOnInit(): void {
        this.activeRootMenu = this.appData.activeRootMenu;
    }

    public clickMenu(menuPermissionActive: string, menu: MarketingMenuEnum) {
        this.menuPermissionActive = menuPermissionActive;
		this.activeMenu = menu;
    }
}
